/**
 * Generated from IntroLayout.fla
 */
export function IntroLayout(this: IIntroLayout) {
	const bg = this.bg;
	IntroLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const grover = this.grover;
	IntroLayout_grover.call(this.grover);
	grover.x = 499;
	grover.y = 663;
	grover.width = 194.00;
	grover.height = 427.00;
	if (grover.onLayout) grover.onLayout();
	const skipButton = this.skipButton;
	IntroLayout_skipButton.call(this.skipButton);
	skipButton.x = 739.3;
	skipButton.y = 617.3;
	skipButton.width = 156.50;
	skipButton.height = 161.50;
	if (skipButton.onLayout) skipButton.onLayout();
	const bee = this.bee;
	IntroLayout_bee.call(this.bee);
	bee.x = 798.25;
	bee.y = 222.75;
	bee.width = 54.50;
	bee.height = 55.55;
	if (bee.onLayout) bee.onLayout();
	return this;
}
function IntroLayout_bg(this: IIntroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("main-menu-bg.png", 0.500, 0.500);
	return this;
}
function IntroLayout_grover(this: IIntroLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grover-stand.png", 0.500, 1.000);
	return this;
}
function IntroLayout_skipButton(this: IIntroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("skip-btn.png", 0.500, 0.500);
	return this;
}
function IntroLayout_bee(this: IIntroLayout_bee) {
	if (this.setLayoutTexture) this.setLayoutTexture("bee.png", 0.500, 0.500);
	return this;
}
interface IIntroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IIntroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IIntroLayoutSprite extends IIntroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IIntroLayoutText extends IIntroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IIntroLayoutPolygon extends Array<number> {
}
interface IIntroLayout {
	readonly bg: IIntroLayout_bg;
	readonly grover: IIntroLayout_grover;
	readonly skipButton: IIntroLayout_skipButton;
	readonly bee: IIntroLayout_bee;
}
interface IIntroLayout_bg extends IIntroLayoutSprite {
}
interface IIntroLayout_grover extends IIntroLayoutSprite {
}
interface IIntroLayout_skipButton extends IIntroLayoutSprite {
}
interface IIntroLayout_bee extends IIntroLayoutSprite {
}
